export default "__VITE_ASSET__7ebccb52__"